import ControlProps from '../../../mixins/ControlProps';
import { CardsProperty } from '../enums';

const CardsProps = {
  props: {
    ...ControlProps.props,
    [CardsProperty.Options]: {
      default: () => ([]),
      type: Array,
    },
    [CardsProperty.Multiple]: {
      default: false,
      type: Boolean,
    },
  },
};

export default CardsProps;
